import { FC, ReactElement } from 'react';
import { FormControl, FormErrorMessage, FormLabel, Skeleton } from '@chakra-ui/react';
import { Field, FieldInputProps, FormikValues } from 'formik';
import { CbInput } from '../Inputs/CbInput';
export interface CbFormikInputFieldProps extends Partial<FieldInputProps<FormikValues>> {
  error?: string | string[];
  leftIcon?: ReactElement;
  touched?: boolean;
  fieldId: string;
  fieldName?: string;
  placeholder: string;
  isDisabled?: boolean;
  isLoading?: boolean;
  color?: string;
  type?: string;
}
const StyledInput = ({
  field,
  ...props
}) => {
  return <CbInput {...field} {...props} data-sentry-element="CbInput" data-sentry-component="StyledInput" data-sentry-source-file="CbFormikInputField.tsx" />;
};
export const CbFormikInputField: FC<CbFormikInputFieldProps> = ({
  onBlur,
  onChange,
  error,
  leftIcon,
  touched,
  fieldId,
  fieldName,
  placeholder,
  isDisabled,
  isLoading,
  color,
  type
}) => {
  if (isLoading) {
    return <Skeleton height="20px" marginY={3} />;
  }
  const isInvalid = !!error && touched;
  return <FormControl isInvalid={isInvalid} data-sentry-element="FormControl" data-sentry-component="CbFormikInputField" data-sentry-source-file="CbFormikInputField.tsx">
      {fieldName && <FormLabel htmlFor={fieldId}>{fieldName}</FormLabel>}

      <Field isDisabled={isDisabled} onChange={onChange} size="md" id={fieldId} name={fieldId} component={StyledInput} onBlur={onBlur} placeholder={placeholder} lefticon={leftIcon} color={color} type={type} data-sentry-element="Field" data-sentry-source-file="CbFormikInputField.tsx" />

      <FormErrorMessage marginTop=".25rem" marginLeft={2} paddingTop={0} data-sentry-element="FormErrorMessage" data-sentry-source-file="CbFormikInputField.tsx">
        {error}
      </FormErrorMessage>
    </FormControl>;
};